export default __webpack_public_path__ + "static/media/image12.3f0015c4.svg";